import './Stylesheet.scss';
import { ToastContainer } from 'react-toastify';
import Router from './Router';

require('dotenv').config();

const App = () => {
  return (
    <div>
      <ToastContainer position="top-center" />
      <Router />
    </div>
  );
}

export default App;